import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61a871d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "i", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "alomigoBlue",
    title: $setup.t('leftHomeName')
  }, [
    _createTextVNode(" Alom"),
    _hoisted_2,
    _createTextVNode("go ")
  ], 8, _hoisted_1))
}